import { Component, OnInit, Input } from '@angular/core';

import { CustomerAddress } from 'src/app/module/customer-address/customer-address.model';

@Component({
  selector: 'app-customer-address',
  templateUrl: './customer-address.component.html',
  styleUrls: ['./customer-address.component.scss'],
})
export class CustomerAddressComponent {

  @Input() customerAddress: CustomerAddress = new CustomerAddress();
  showInfo: boolean = false;

  constructor() {}

  ngOnChanges(test:any) {
    // si le panier change, vérifier si on peut enlever le produit
    if (this.customerAddress != null) {
      if (this.customerAddress.transportFeeAmount != null ||
          this.customerAddress.minimumAmountForFreeTransportFee != null ||
          this.customerAddress.freeTransportFeeAmount != null ||
          this.customerAddress.compteDeCollecte != null ||
          this.customerAddress.orderDisposition != null ||
          this.customerAddress.shipVia != null) 
            this.showInfo = true;
          else
            this.showInfo = false;
    }
    else 
      this.showInfo = false;
  }
}
